import { Component } from "react";
import {app} from "./App";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { Button,Modal} from 'react-bootstrap'; 


export class Contact extends Component{  
  constructor (props){
    super(props);
    this.state = {

     questionlist:[],
     questionsFAList:[],
     checked:[],
     defaultcheck:"",
     show:false,
     checkedItems: new Map()
    };
    this.handleChange = this.handleChange.bind(this);
    
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
  componentDidMount() {
    if(document.referrer == ""){
      window.location.replace('https://as-mobilization-stage.accenture.com/Nest-Home.aspx');
    }
    else
    {
    this.state.checked = Array.prototype.slice.call(document.querySelectorAll('input:checked'));
    
    for(var i = 0; i < this.state.checked.length; i++) {
      if(!this.state.defaultcheck.toString().includes(this.state.checked[i].value))
      {
      this.state.defaultcheck =  this.state.checked[i].value+','+this.state.defaultcheck; 
      }
    }
    console.log(this.state.defaultcheck);
    console.log(this.props.location.state.AppName);
    document.title = "KTPlanConfigurator";
    const FunctionalAreaName = this.props.location.state.FunctionalAreaName;
    if(FunctionalAreaName !="BFSI" && FunctionalAreaName!="Pharma"){
      document.getElementById('FunctionalAreaTasks').style.display = 'none';
    }
    else{
      document.getElementById('FunctionalAreaTasks').style.display = 'block';
    }
  }
  }

  handleChange(event) {
    var isChecked = event.target.checked;
    var item = event.target.value;
    
    this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
    let newArray = [...this.state.questionlist, event.target.value];
    if (this.state.questionlist.includes(event.target.value)) {
      newArray = newArray.filter(day => day !== event.target.value);
    }
    this.setState({
      questionlist: newArray
    });
} 

handleChange1(event) {
  var isChecked = event.target.checked;
  var item = event.target.value;
  
  this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
  let newArray = [...this.state.questionsFAList, event.target.value];
  if (this.state.questionsFAList.includes(event.target.value)) {
    newArray = newArray.filter(day => day !== event.target.value);
  }
  this.setState({
    questionsFAList: newArray
  });
} 



handleSubmit(event) {
//event.preventDefault();
}

downloadEmployeeData = (event) => { var AppArray = this.props.location.state.AppName.split(','); console.log(this.props.location.state.AppName); for(let i=0;i<AppArray.length;i++) { if(AppArray[i] != "") { 
  fetch('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Questions/GetLevel2Topics?TaskIds='+this.props.location.state.technology+';'+this.state.questionlist+','+this.state.defaultcheck+';'+this.props.location.state.FunctionalAreaName) .then(response => { response.blob().then(blob => { let url = window.URL.createObjectURL(blob); let a = document.createElement('a'); a.href = url; if(this.props.location.state.servicegroup =="AO") { a.download =this.props.location.state.ClinetNamePass+"KTPlan_"+AppArray[i]+".xlsx"; } else { a.download =this.props.location.state.ClinetNamePass+"KTPlan_"+this.props.location.state.AppNamepass+".xlsx"; } a.click(); this.setState({show:true}) }); }); } }}


  Back = (event) => {
    if(this.props.location.state.STExecIdPass != "0" )
      {
    this.props.history.push({
      
      pathname: '/',
      search: '?STExecId='+this.props.location.state.STExecIdPass+'&username='+this.props.location.state.username
      
    }) 
  }
  else
  {
    this.props.history.push({
      
      pathname: '/',
      search: '?username='+this.props.location.state.username,
      
    }) 
  }
  }

  gettech() {
      fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/TechnologyList/").then(response => response.json())
    .then(res=> {            
      this.setState ( { techlist: res } )
        })
        .catch(err => {
          console.log(err);
      }) 
  
  }

  handleModal(){  
    this.setState({show:!this.state.show})  
  } 
render() {
 
   const questionlist = this.props.location.state.questions;
   const newarr =this.props.location.state.questions;
   const questionsFAList = this.props.location.state.QuestionsFunctionalArea;
   const newFAList = this.props.location.state.QuestionsFunctionalArea;
   console.log(questionlist);
   console.log(questionsFAList);
   
    return (
     
        <div class="bg-background" style={{background:'#F2F2F2'}}>
          <div class="row">
              <div class="container-fluid">
              <label style={{marginLeft:17,color:'#460073'}}><b>KT Tasks/Activities</b></label>
                <div class="demographic-form margin-top15 border-main-div new-KT">
                <div class="col-md-12">
                  <div class="heading-desc col-md-10" >
                      <span class="font-bold">Please select the Tasks/Activities to include in KT Plan? </span> (KT Lead can select multiple options)
                  </div>
                
                    
                  </div>
                     
                
                     
                      <div class="col-md-12"> 
                        {
                          questionlist.map(list =>
                      <div >
                      
                      <Accordion style={{display:list.sectionheader==""?'none':'block', marginBottom:5}} >
                      
                      <AccordionSummary style={{height:15,background:'#eed4fd'}} expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
                        <Typography style={{fontWeight: 10,marginBottom:2,}}>
                        <label class="sectionhead">{list.sectionheader2}</label>
                        <label style={{display:'inline-block'}}>{list.sectionheader}</label>
                        </Typography>
                      </AccordionSummary>
                      
                      <AccordionDetails>
                        <Typography>                        
                                        {
                                          newarr.map(newlist =>
                                            <div class="sidebyside" style={{display:newlist.header ==list.header?'block':'none'}}>
                                            <label class="" style={{marginLeft:30}}>
                                            <span class="labelclass" style={{fontWeight:'normal'}}>
                                            <input id={newlist.value} style={{marginRight:10}} class="Chkques" defaultChecked={newlist.mandatory} disabled={newlist.mandatory}   onChange={this.handleChange}  type="checkbox" value={newlist.value} />
                                            {  newlist.text  }    
                                            
                                            </span>  </label> </div>  
                                        
                                      )}                                      
                          </Typography>
                      </AccordionDetails>

                    </Accordion>          
                     </div>
                        )}
                     </div>
                      
                     <div id = "FunctionalAreaTasks" class="heading-desc col-md-12" style={{marginTop:10, marginBottom:5,marginLeft:15}}>
                      <span class="font-bold">Functional Area Tasks </span>
                  </div>
                  <div class="col-md-12"> 
                  
                        {
                          questionsFAList.map(list =>
                      <div >
                      
                      <Accordion style={{display:list.sectionheader==""?'none':'block', marginBottom:5}} >
                      
                      <AccordionSummary style={{height:15,background:'#eed4fd'}} expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
                        <Typography style={{fontWeight: 10,marginBottom:2,}}>
                        <label class="sectionhead">{list.sectionheader2}</label>
                        <label style={{display:'inline-block'}}>{list.sectionheader}</label>
                        </Typography>
                      </AccordionSummary>
                      
                      <AccordionDetails>
                        <Typography>                        
                                        {
                                          newFAList.map(newlist =>
                                            <div class="sidebyside" style={{display:newlist.header ==list.header?'block':'none'}}>
                                            <label class="" style={{marginLeft:30}}>
                                            <span class="labelclass" style={{fontWeight:'normal'}}>
                                            <input id={newlist.value} style={{marginRight:10}} class="Chkques" defaultChecked={newlist.mandatory} disabled={newlist.mandatory}   onChange={this.handleChange}  type="checkbox" value={newlist.value} />
                                            {  newlist.text  }    
                                            
                                            </span>  </label> </div>  
                                        
                                      )}                                      
                          </Typography>
                      </AccordionDetails>

                    </Accordion>          
                     </div>
                        )}
                     </div>

                      <div class="col-md-12 mb-1">
                        <input type="submit" style={{width:160}} onClick={this.downloadEmployeeData} name="ctl00$ContentPlaceHolder1$btnCancel" value="Generate KT Plan" id="ContentPlaceHolder1_btnCancel" class="btn-new btn-confirm"/>
                        <input type="submit"  onClick={this.Back} style={{background:'#b455aa'}} name="ctl00$ContentPlaceHolder1$btnSave" value="Back" id="ContentPlaceHolder1_btnSave" class="btn-new btn-back"/>
                      </div>
    
                      
                   
                      
                </div>
          </div>
        </div>
        <Modal show={this.state.show}  style={{opacity:1}} onHide={()=>this.handleModal()}>  
        <div class="pdf-generate">
                      <Modal.Body>
                        <img src="images/success.PNG"></img>
                        <label>Plan Generated successfully</label>
                      
                        </Modal.Body>  
                        </div>
                    </Modal>  
                    <footer style={{background:'#F2F2F2',height:210}}>© 2026 Accenture. All Rights Reserved.
      </footer>
      </div>
    )}
}
  
export default Contact;